import { getUser } from "../services/Auth";
import api from "./api";

export const ListarCorredores = async () => {
  try {
    const usuario = await getUser();
    const corredores = await api.get(
      `/estabelecimentos/${usuario.estabelecimento._id}/corredores`,
    );
    return corredores.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarCorredor = async (data) => {
  try {
    const corredores = await api.post(`/corredores`, data);
    return corredores.data;
  } catch (error) {
    throw error;
  }
};

export const EditarCorredor = async (data, id) => {
  try {
    const corredores = await api.put(`/corredores/${id}`, data);
    return corredores.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarCorredor = async (id) => {
  try {
    const corredores = await api.put(`/corredores/${id}`, { ativo: false });
    return corredores.data;
  } catch (error) {
    throw error;
  }
};
